(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const initializeProductSection = (root) => {
      const sections = root.matches && root.matches('[data-product-gallery-section]')
        ? [root]
        : Array.from(root.querySelectorAll('[data-product-gallery-section]'));

      sections.forEach((section) => {
        if (section.dataset.productSectionReady === 'true') return;
        section.dataset.productSectionReady = 'true';

        const mainImage = section.querySelector('.ab-main-product__main-image');
        const thumbnails = Array.from(section.querySelectorAll('[data-product-thumbnail]'));
        if (mainImage && thumbnails.length > 0) {
          thumbnails.forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => {
              const nextSource = thumbnail.dataset.gallerySrc;
              if (!nextSource) return;

              const updateImage = () => {
                mainImage.removeAttribute('srcset');
                mainImage.removeAttribute('sizes');
                mainImage.src = nextSource;
                mainImage.alt = thumbnail.dataset.galleryAlt || '';
                thumbnails.forEach((item) => item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false'));
              };

              if (document.startViewTransition) {
                document.startViewTransition(updateImage);
              } else {
                updateImage();
              }
            });
          });
        }

        const variantSelector = section.querySelector('[data-variant-selector]');
        const currentPrice = section.querySelector('[data-current-price]');
        const comparePrice = section.querySelector('[data-compare-price]');
        const priceDivider = section.querySelector('[data-price-divider]');
        const submitButton = section.querySelector('[data-product-submit]');

        if (variantSelector) {
          variantSelector.addEventListener('change', () => {
            const option = variantSelector.selectedOptions[0];
            if (!option) return;

            if (currentPrice) currentPrice.textContent = option.dataset.price || '';
            const hasComparePrice = Boolean(option.dataset.comparePrice);
            if (comparePrice) {
              comparePrice.textContent = option.dataset.comparePrice || '';
              comparePrice.hidden = !hasComparePrice;
            }
            if (priceDivider) priceDivider.hidden = !hasComparePrice;

            if (submitButton) {
              const isAvailable = option.dataset.available === 'true';
              submitButton.disabled = !isAvailable;
              submitButton.textContent = isAvailable
                ? submitButton.dataset.availableLabel
                : submitButton.dataset.unavailableLabel;
            }
          });
        }

        if (section.hasAttribute('data-catakor-offers')) {
          const slot = section.querySelector('[data-catakor-offer-slot]');
          const mobile = window.matchMedia('(max-width: 749px)');
          let originalPosition;

          const positionOffers = () => {
            const form = section.querySelector('.shopify-product-form');
            const offers = form?.querySelector('.rsi_embedded_quantity_wrapper')
              || slot?.querySelector('.rsi_embedded_quantity_wrapper');
            if (!form || !slot || !offers) return;

            if (!originalPosition) {
              originalPosition = document.createElement('span');
              originalPosition.hidden = true;
              form.parentNode.insertBefore(originalPosition, form);
            }

            if (mobile.matches && form.parentNode !== slot) {
              slot.appendChild(form);
            } else if (!mobile.matches && form.parentNode === slot && originalPosition.parentNode) {
              originalPosition.parentNode.insertBefore(form, originalPosition.nextSibling);
            }
          };

          const offerObserver = new MutationObserver(positionOffers);
          offerObserver.observe(section, { childList: true, subtree: true });
          mobile.addEventListener('change', positionOffers);
          positionOffers();
        }
      });
    };

    const initializePage = () => initializeProductSection(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePage, { once: true });
    } else {
      initializePage();
    }

    document.addEventListener('shopify:section:load', (event) => initializeProductSection(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temperature-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTemperatureEditorial = (root) => {
      const sections = root.matches && root.matches('[data-temperature-editorial]')
        ? [root]
        : Array.from(root.querySelectorAll('[data-temperature-editorial]'));

      sections.forEach((section) => {
        if (section.dataset.temperatureEditorialReady === 'true') return;
        section.dataset.temperatureEditorialReady = 'true';

        const triggers = Array.from(section.querySelectorAll('[data-temperature-trigger]'));
        const cards = Array.from(section.querySelectorAll('[data-temperature-card]'));
        const description = section.querySelector('[data-temperature-description]');
        const preview = section.querySelector('[data-temperature-preview]');
        const previewImage = preview ? document.createElement('img') : null;
        const desktopHover = window.matchMedia('(min-width: 750px) and (hover: hover)');
        let activePreviewCard = null;

        const fitPreviewToImage = () => {
          if (!preview || !previewImage || previewImage.naturalWidth === 0) return;
          if (!section.classList.contains('temperature-editorial--preview-auto-fit')) return;

          const sectionStyles = window.getComputedStyle(section);
          const configuredWidth = Number.parseFloat(sectionStyles.getPropertyValue('--te-preview-width')) || 420;
          const previewPadding = Number.parseFloat(sectionStyles.getPropertyValue('--te-preview-padding')) || 0;
          const previewBorder = Number.parseFloat(sectionStyles.getPropertyValue('--te-preview-border-width')) || 0;
          const frameSpace = (previewPadding + previewBorder) * 2;
          const availableWidth = Math.max(120, section.clientWidth - 48);
          const availableHeight = Math.max(120, section.clientHeight - 48);
          const imageRatio = previewImage.naturalWidth / previewImage.naturalHeight;
          let contentWidth = Math.max(1, Math.min(configuredWidth, availableWidth) - frameSpace);
          let contentHeight = contentWidth / imageRatio;

          if (contentHeight + frameSpace > availableHeight) {
            contentHeight = Math.max(1, availableHeight - frameSpace);
            contentWidth = contentHeight * imageRatio;
          }

          preview.style.setProperty('--te-preview-auto-width', `${Math.round(contentWidth + frameSpace)}px`);
          preview.style.setProperty('--te-preview-auto-height', `${Math.round(contentHeight + frameSpace)}px`);
        };

        const hidePreview = () => {
          activePreviewCard = null;
          if (!preview) return;
          preview.classList.remove('is-visible');
          preview.setAttribute('aria-hidden', 'true');
        };

        if (previewImage) {
          previewImage.dataset.temperaturePreviewImage = '';
          previewImage.alt = '';
          previewImage.decoding = 'async';
          previewImage.addEventListener('error', hidePreview);
          preview.appendChild(previewImage);
        }

        const showPreview = (card) => {
          if (!desktopHover.matches || !preview || !previewImage) return;
          const sourceImage = card.querySelector('.temperature-editorial__card-image');
          const previewSource = card.dataset.temperaturePreviewSrc || sourceImage?.currentSrc || sourceImage?.src;
          if (!previewSource) return;
          activePreviewCard = card;
          previewImage.alt = card.dataset.temperaturePreviewAlt || sourceImage?.alt || '';
          const revealPreview = () => {
            if (activePreviewCard !== card || previewImage.naturalWidth === 0) return;
            fitPreviewToImage();
            preview.classList.add('is-visible');
            preview.setAttribute('aria-hidden', 'false');
          };
          if (previewImage.src !== previewSource) {
            previewImage.src = previewSource;
          }
          if (previewImage.complete) {
            revealPreview();
          } else {
            previewImage.addEventListener('load', revealPreview, { once: true });
          }
        };

        triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const selectedIndex = trigger.dataset.temperatureIndex;

            triggers.forEach((item) => {
              const isSelected = item === trigger;
              item.classList.toggle('is-active', isSelected);
              item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            });

            cards.forEach((card) => {
              card.classList.toggle('is-active', card.dataset.temperatureIndex === selectedIndex);
            });

            if (description) {
              const message = section.querySelector(`[data-temperature-message][data-temperature-index="${selectedIndex}"]`);
              description.innerHTML = message ? message.innerHTML : '';
            }
          });
        });

        cards.forEach((card) => {
          card.addEventListener('mouseenter', () => showPreview(card));
          card.addEventListener('mouseleave', hidePreview);
          card.addEventListener('focusin', () => showPreview(card));
          card.addEventListener('focusout', hidePreview);
        });

        if (typeof desktopHover.addEventListener === 'function') {
          desktopHover.addEventListener('change', hidePreview);
        } else if (typeof desktopHover.addListener === 'function') {
          desktopHover.addListener(hidePreview);
        }

        if (typeof ResizeObserver === 'function') {
          const previewResizeObserver = new ResizeObserver(() => {
            if (activePreviewCard) fitPreviewToImage();
          });
          previewResizeObserver.observe(section);
        }
      });
    };

    const initializePage = () => initializeTemperatureEditorial(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePage, { once: true });
    } else {
      initializePage();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeTemperatureEditorial(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
